export const sdkVersionHeaderName = 'X-SDK-Version';
export const countryCodeHeaderName = 'X-Country-Code';
export const currencyHeaderName = 'X-Currency';
export const languageHeaderName = 'X-Language';
export const siteUrlHeaderName = 'X-Site-Url';
export const checkoutPageUrlHeaderName = 'X-Checkout-Page-Url';
export const pspHeaderName = 'X-PSP';
export const atlasSessionIdHeaderName = 'X-Atlas-Session-Id';
export const showOrderConfirmationQueryParam = 'showOrderConfirmation';
export const orderIdQueryParam = 'orderId';
export const paymentErrorQueryParam = 'paymentError';
//# sourceMappingURL=constants.js.map